export const EQUALS = '==';

export const GREATER_THEN = '>';

export const LOWER_THEN = '<';

export const LOWER_THEN_OR_EQUAL = '<=';

export const GREATER_THEN_OR_EQUAL = '>=';
